import { StudentDocumentsStatusInfo } from '@/helpers/postgradStudentDocuments/interfaces';
import { CourseCertificateInfo } from '@/models/studentDocuments';

export interface PostgradStudentDocumentsState {
  documentsStatus: { [courseId: string]: StudentDocumentsStatusInfo | null };
  certificateInfo: { [courseId: string]: CourseCertificateInfo };
}

const state: PostgradStudentDocumentsState = {
  documentsStatus: {},
  certificateInfo: {},
};

export default state;
